import { render, staticRenderFns } from "./m-footer.vue?vue&type=template&id=24270165&scoped=true"
import script from "./m-footer.vue?vue&type=script&lang=js"
export * from "./m-footer.vue?vue&type=script&lang=js"
import style0 from "./m-footer.vue?vue&type=style&index=0&id=24270165&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24270165",
  null
  
)

export default component.exports